import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "as-incident-list" }
const _hoisted_2 = { class: "as-incident-list__head" }
const _hoisted_3 = { class: "as-head-current" }
const _hoisted_4 = { class: "as-match-time" }
const _hoisted_5 = { class: "as-match-status" }
const _hoisted_6 = { class: "as-head-scores-round" }
const _hoisted_7 = { class: "as-round-name" }
const _hoisted_8 = { class: "as-round-scores" }
const _hoisted_9 = { class: "as-round-scores__as-home" }
const _hoisted_10 = { class: "as-round-scores__as-away" }
const _hoisted_11 = { class: "as-incident-list__body" }
const _hoisted_12 = { class: "as__left" }
const _hoisted_13 = { class: "as__right" }

import { computed } from "vue";
import { useMatchDetailStore } from "~src/stores/MatchDetailStore";
import { usecommonStore } from "~src/stores/CommonStore";
import SkeletonLoader from "~src/components/SkeletonLoader.vue";

const __default__ = {};

interface IProps {
  isHomePage?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'IncidentsListSkeleton',
  props: {
    isHomePage: { type: Boolean, default: false }
  },
  setup(__props: any) {

const commonStore = usecommonStore();
const matchDetailStore = useMatchDetailStore();

const props = __props;

const siteName = computed(() => commonStore.getSiteName);
const screenWidth = computed(() => matchDetailStore.getScreenWidth);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(SkeletonLoader, {
            width: "100px",
            height: "20px",
            line: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(SkeletonLoader, {
            width: "100px",
            height: "20px",
            line: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (index) => {
          return _createElementVNode("div", {
            class: "as-head-scores-round__items",
            key: index
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(SkeletonLoader, {
                width: "100px",
                height: "20px",
                line: 1
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(SkeletonLoader, {
                  width: "100px",
                  height: "20px",
                  line: 1
                })
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(SkeletonLoader, {
                  width: "100px",
                  height: "20px",
                  line: 1
                })
              ])
            ])
          ])
        }), 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
        return _createElementVNode("div", {
          class: "as-incident__item",
          key: index
        }, [
          _createVNode(SkeletonLoader, {
            width: "100px",
            height: "20px",
            line: 1
          }),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (index) => {
            return _createElementVNode("div", {
              class: _normalizeClass(`as-incident_row`),
              key: index
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(SkeletonLoader, {
                  width: "100px",
                  height: "20px",
                  line: 1
                })
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(SkeletonLoader, {
                  width: "100px",
                  height: "20px",
                  line: 1
                })
              ])
            ])
          }), 64))
        ])
      }), 64))
    ])
  ]))
}
}

})